const REQUEST_TAG_TYPE = 0;
const RESPONSE_TAG_TYPE = 1;
module.exports = {
  REQUEST_TAG_TYPE,
  RESPONSE_TAG_TYPE,
};
